// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.inspection-questions-chart-container[data-v-8dbe8e76] {\n    /* Adjust height as needed, horizontal bars might need more vertical space */\n    height: 200px;\n    width: 100%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
